export const lessonFlow = [
  { time: '5 min', label: 'Hook', detail: 'Introduce a short fictional school situation.' },
  { time: '5 min', label: 'Mini-lesson', detail: 'Use the read-aloud script to introduce the skill.' },
  { time: '10 min', label: 'Guided activity', detail: 'Explore different feelings that could fit.' },
  { time: '5 min', label: 'Worksheet', detail: 'Choose K–2 or grades 3–5 practice.' },
  { time: '5 min', label: 'Reflect + check', detail: 'Ask the closing questions and check understanding.' },
];

export const lessonIncludes = [
  'An opening hook to introduce the topic.',
  'A mini-lesson script you can read and adapt.',
  'A guided activity with simple materials.',
  'Worksheets for K–2 and grades 3–5.',
  'Three reflection questions and an exit check.',
  'A family note to continue the conversation.',
];
